<div *ngIf="headerData" class="container-header-events d-flex justify-content-between align-items-start mb-5">
    <div class="container-header-events__title">
        <h2 *ngIf="headerData.titolo" class="ls-h2-section-title text-brand-10 pb-2">{{ headerData.titolo }}</h2>
        <!-- TODO momentaneo. Finche non funzionano le notidiche -->
        <!-- <div class="container-header-events__title__event d-flex">
            <p class="m-0 ls-label-small-semibold text-brand-40 cursor-pointer pb-2 position-relative line-news-hover-bottom">
                <i class="fa fa-light fa-bell me-2"></i>
                <span>RICEVI NOTIFICHE</span>
            </p>
        </div> -->
    </div>
    <div class="container-header-events__cta hidden-phone" *ngIf="headerData.labelLink">
        <a *ngIf="headerData.labelLinkUrl && !isLinkEsternal" [routerLink]="navigationService.splitUrlRouterLink(headerData.labelLinkUrl).path" [queryParams]="navigationService.splitUrlRouterLink(headerData.labelLinkUrl).queryParams">
            <button class="btn-header-news ls-label-small-semibold text-uppercase"
                [innerHTML]="headerData.labelLink"></button>
        </a>
        <a *ngIf="headerData.labelLinkUrl && isLinkEsternal" [href]="headerData.labelLinkUrl">
            <button class="btn-header-news ls-label-small-semibold text-uppercase"
                [innerHTML]="headerData.labelLink"></button>
        </a>
    </div>
</div>